module.exports = __webpack_public_path__ + "static/media/blob.98bb23b2.png";